import React from "react";

const AgentHandoffs = () => {
  return <div></div>;
};

export default AgentHandoffs;
